import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLenovoComponent } from './simple-icons-lenovo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLenovoComponent ],
    exports:      [ SimpleIconsLenovoComponent ],
    bootstrap:    []
})
export class SimpleIconsLenovoModule {}
